import React, { useEffect, useState } from "react";
import mudConfig from "../../../contracts/mud.config";
import { stash } from "../mud/stash";
import { useRecords } from "../mud/useRecords";
import { useWorldContract } from "../mud/useWorldContract";
import { Severity, SmartAssemblyType } from "@eveworld/types";
import { useNotification, useSmartObject } from "@eveworld/contexts";

import {
  EveLoadingAnimation,
  ErrorNotice,
  ErrorNoticeTypes,
} from "@eveworld/ui-components";

import { JSX } from "react/jsx-runtime";
import { findOwnerByAddress } from "@eveworld/utils";

import WelcomePlayer from "./WelcomePlayer";
import InventoryListItem from "./InventoryListItem";
import InventoryListView from "./InventoryListView";
import HighScorePlayer from "./HighScorePlayer";
import { bigIntSort } from "@latticexyz/common/utils";

import {
  DataGrid,
  GridColDef,
  GridRowsProp,
  GridValidRowModel,
} from "@mui/x-data-grid";
import { Stack } from "@mui/material";

const HeadHunters = React.memo(
  () //   {
  : JSX.Element => {
    const { smartAssembly, smartCharacter, loading } = useSmartObject();
    const { notify, handleClose } = useNotification();

    const { worldContract } = useWorldContract();

    const [isShowingHighScores, setIsShowingHighScores] = useState(false);

    var highScorePlayerAddress1st: string = "";
    var highScorePlayerAddress2nd: string = "";
    var highScorePlayerAddress3rd: string = "";
    var currentPlayerRowId: number = 0;
    var currentPlayerPoints: number = 0;

    const isShowingHighScoresChange = () => {
      setIsShowingHighScores(!isShowingHighScores);
    };

    const highScoreRecords = useRecords({
      stash,
      table: mudConfig.namespaces.Tapticc.tables.HeadHunters,
    });

    const highScoreEntities = React.useMemo(() => {
      return Object.values(highScoreRecords).sort((a, b) =>
        bigIntSort(b.points, a.points)
      ); //b then a to sort descending
    }, [highScoreRecords]);

    useEffect(() => {
      if (loading) {
        notify({ type: Severity.Info, message: "Loading..." });
      } else {
        handleClose();
      }
    }, [loading]);

    if ((!loading && !smartAssembly) || !smartAssembly?.isValid) {
      return <ErrorNotice type={ErrorNoticeTypes.SMART_ASSEMBLY} />;
    }

    var smartStorageUnit =
      smartAssembly as SmartAssemblyType<"SmartStorageUnit">;

    var ephemeralInventoryList =
      smartStorageUnit.inventory.ephemeralInventoryList;

    const playerInventory = ephemeralInventoryList.find((x) =>
      findOwnerByAddress(x.ownerId, smartCharacter.address)
    );

    const inventoryList: JSX.Element[] = [];
    if (playerInventory) {
      var ephemeralInventoryItems = playerInventory.ephemeralInventoryItems;
      if (ephemeralInventoryItems) {
        ephemeralInventoryItems.forEach((ephemeralInventoryItem) => {
          if (
            ephemeralInventoryItem.itemId ==
            10320968629285791192887907704109390747885911712003174839528149865334533810428 //strangers head item id
          ) {
            inventoryList.push(
              <InventoryListItem
                ephemeralInventoryItem={ephemeralInventoryItem}
                key={ephemeralInventoryItem.itemId}
              ></InventoryListItem>
            );
          }
        });
      } else {
        inventoryList.push(
          <tr key="ephemeralInventoryItemsNotSet">
            <td>
              You have no items in this SSU, start depositing Strangers Heads
              now and get claiming points!
            </td>
          </tr>
        );
      }
    } else {
      inventoryList.push(
        <tr key="playerInventoryNotSet">
          <td>
            You have no items in this SSU, start depositing Strangers Heads now
            and get claiming points!
          </td>
        </tr>
      );
    }

    const columns: GridColDef[] = [
      { field: "id", headerName: "#", width: 50 },
      { field: "colSmartCharacterId", headerName: "#", width: 50 },
      { field: "colCharacterName", headerName: "Player Name", width: 350 },
      { field: "colPoints", headerName: "Points", width: 150 },
    ];

    const rows: GridValidRowModel[] = [];

    var rowId: number = 0;

    if (highScoreEntities) {
      Object.entries(highScoreEntities).forEach((highScore) => {
        const [id, data] = highScore;

        const smartCharacterId = data.smartCharacterId;
        const characterName = data.characterName;
        const points = Number(data.points);

        if (points > 0) {
          rowId++;

          const row: GridValidRowModel = {
            id: rowId,
            colSmartCharacterId: smartCharacterId,
            colCharacterName: characterName,
            colPoints: points,
          };
          rows.push(row);

          if (rowId == 1) {
            highScorePlayerAddress1st = row.colSmartCharacterId;
          }
          if (rowId == 2) {
            highScorePlayerAddress2nd = row.colSmartCharacterId;
          }
          if (rowId == 3) {
            highScorePlayerAddress3rd = row.colSmartCharacterId;
          }

          if (
            row.colSmartCharacterId.toUpperCase() ==
            smartCharacter.address.toString().toUpperCase()
          ) {
            currentPlayerRowId = rowId;
            currentPlayerPoints = Number(row.colPoints);
          }
        }
      });
    }

    const rowProps: GridRowsProp = rows;

    console.log(rows);

    var currentPositionMessage: string = "";
    if (currentPlayerPoints == 0) {
      currentPositionMessage = "You haven't earnt any points as yet :-\\";
    } else {
      currentPositionMessage =
        "You are currently ranked in position #" +
        currentPlayerRowId.toString() +
        ", with " +
        currentPlayerPoints.toString() +
        " points.";
    }

    return (
      <>
        <EveLoadingAnimation position="diagonal">
          {/* <div className="grid border border-brightquantum bg-crude"> */}
          <div className="grid border border-brightquantum">
            {isShowingHighScores && (
              <button
                onClick={isShowingHighScoresChange}
                style={{ backgroundColor: "black" }}
              >
                Click here to view inventory
              </button>
            )}
            {!isShowingHighScores && (
              <button
                onClick={isShowingHighScoresChange}
                style={{ backgroundColor: "black" }}
              >
                Click here to view high scores
              </button>
            )}
            <WelcomePlayer></WelcomePlayer>
            {!isShowingHighScores && (
              <InventoryListView
                inventoryList={inventoryList}
              ></InventoryListView>
            )}
            {isShowingHighScores && (
              <div
                style={{
                  height: 130,
                  width: "100%",
                  // zoom: "80%",
                  alignContent: "center",
                  backgroundColor: "black",
                }}
              >
                <Stack
                  direction="row"
                  spacing={5}
                  alignSelf={"center"}
                  marginTop={"15px;"}
                  marginBottom={"15px;"}
                  marginLeft={"15px"}
                >
                  <HighScorePlayer
                    characterAddress={highScorePlayerAddress1st}
                    characterPosition="First:"
                    rewardDetails="30 Exotronics"
                  ></HighScorePlayer>
                  <HighScorePlayer
                    characterAddress={highScorePlayerAddress2nd}
                    characterPosition="Second:"
                    rewardDetails="20 Exotronics"
                  ></HighScorePlayer>
                  <HighScorePlayer
                    characterAddress={highScorePlayerAddress3rd}
                    characterPosition="Third:"
                    rewardDetails="10 Exotronics"
                  ></HighScorePlayer>
                  {/* <p>{currentPositionMessage}</p> */}
                  <div className="font-normal text-xs !py-4">
                    {currentPositionMessage}
                  </div>
                </Stack>
              </div>
            )}
          </div>
          <div className="grid border border-brightquantum">
            {isShowingHighScores && (
              <div
                style={{
                  height: 300,
                  width: "100%",
                  // zoom: "80%",
                  alignContent: "center",
                }}
              >
                <DataGrid
                  density="compact"
                  disableColumnFilter={true}
                  disableColumnMenu={true}
                  disableColumnResize={true}
                  disableColumnSelector={true}
                  initialState={{
                    columns: {
                      columnVisibilityModel: {
                        // Hide colSmartCharacterId, the other columns will remain visible
                        colSmartCharacterId: false,
                      },
                    },
                    sorting: {
                      sortModel: [{ field: "colPoints", sort: "desc" }],
                    },
                  }}
                  style={{ backgroundColor: "black" }}
                  sx={{
                    "& .MuiDataGrid-columnHeader, & .MuiDataGrid-cell": {
                      backgroundColor: "black",
                      color: "white",
                    },
                  }}
                  getRowId={(row: any) => row.id}
                  rows={rowProps}
                  columns={columns}
                />
              </div>
            )}
          </div>
        </EveLoadingAnimation>
      </>
    );
  }
);

export default React.memo(HeadHunters);
